import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Avatar, AvatarImage, AvatarFallback } from 'components/ui/avatar'
import Layout from 'components/Layout'
import { ChevronRight as ChevronRightIcon } from 'lucide-react'
import { initializeMyPartnerApps } from 'slices/myPartnerAppSlice'

function SidebareMyPartnerApps() {
	const dispatch = useDispatch()

	const {
		entities: appEntities,
		ids: myPartnerAppIds,
		isLoading: myPartnerAppsLoading,
		isInitialized: myPartnerAppsInitialized,
	} = useSelector(state => state.myPartnerApps)
	const partnerApps = myPartnerAppIds.map(id => appEntities[id])

	console.log('My - partnerApps: ', partnerApps)

	useEffect(() => {
		dispatch(initializeMyPartnerApps())
	}, [dispatch])

	return (
		<Layout.SidebarItem title="My Apps">
			{myPartnerAppsInitialized ? (
				<div>
					{partnerApps.map((app, index) => (
						<a key={index} href={`/partnerapps/${app.partnerApp._id}`} className="flex items-center px-4 py-2 hover:bg-gray-50 no-underline text-inherit">
							<Avatar className="h-9 w-9 mr-3 shrink-0">
								<AvatarImage src={app.partnerApp.image} />
								<AvatarFallback />
							</Avatar>
							<div className="flex-1 min-w-0 text-sm text-gray-900">{app.partnerApp.appName}</div>
							<ChevronRightIcon className="w-4 h-4 text-gray-400 shrink-0 ml-2" />
						</a>
					))}
				</div>
			) : null}
		</Layout.SidebarItem>
	)
}

export default SidebareMyPartnerApps
